module.exports = __webpack_public_path__ + "static/bilingualism@large-ca5669143787bb53a7799883dfeefc26.jpg";